import React from "react";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";

const UserList = ({
  userList,
  selectedCompany = false,
  merchant = false,
  duplicateEmails = new Set(),
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-row flex-wrap gap-2">
      {merchant &&
        userList.map((user) => {
          const emailKey = (user.email || "").trim().toLowerCase();
          const isDuplicate = duplicateEmails.has(emailKey);
          const isInactive = user.active === false;

          return (
            <div
              key={user._id}
              className={`w-1/4 p-4 cursor-pointer partnerCompanyUserListItem ${
                isInactive ? "opacity-80 border border-red-300" : ""
              }`}
              onClick={() => {
                selectedCompany
                  ? navigate("/partner/" + selectedCompany._id + "/user/" + user._id)
                  : navigate(`/merchant/${merchant._id}/user/${user._id}`);
              }}
            >
              <div className="flex flex-wrap gap-2 mb-2">
                {isInactive && <Chip size="small" color="error" variant="outlined" label="Inactive" />}
                {isDuplicate && (
                  <Chip size="small" color="warning" variant="outlined" label="Duplicate email" />
                )}
                {user.role && (
                  <Chip size="small" variant="outlined" label={user.role === "admin" ? "Admin" : "Sales"} />
                )}
              </div>
              <h2 className={`text-2xl font-bold ${isInactive ? "text-red-600" : ""}`}>
                {user.firstName} {user.lastName}
              </h2>
              <div className="flex flex-column gap-2 inline-flex w-full">
                <div className="flex place-content-between gap-2">
                  <span className="font-bold">Status</span>
                  <strong className={isInactive ? "text-red-600" : "text-green-700"}>
                    {isInactive ? "Inactive" : "Active"}
                  </strong>
                </div>
                <span>{user.email}</span>
                <span>{user.phone}</span>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default UserList;
